/* eslint-disable valid-typeof */
import { useQuery } from '@tanstack/react-query';
import useJwt from '../../utils/useJwt';

export type PlacesType = 'address' | 'city' | 'country' | 'postcode';
export interface PlacesFilter {
  type: 'address' | 'city' | 'country' | 'postcode';
  query: string;
}

export type PlacesResponse = {
  hits: {
    details: string;
    matchWords: string[];
    place_id: string;
    locale_names: string[];
  }[];
};

export default function usePlaces({ query, type }: PlacesFilter) {
  const jwt = useJwt();
  let lang = 'FR';
  if (typeof window !== undefined) {
    lang = window.config?.LANGUAGE ?? 'FR';
  }

  const params = {
    query,
    type,
    lang,
    jwt,
  };

  return useQuery<PlacesResponse, Error>({
    queryKey: ['places/verify', params],
    enabled: (query?.length ?? 0) > 0 && !!lang && !!jwt && !!type,
  });
}
